import * as Sentry from '@sentry/vue'
import { bsConstants } from 'booksprout'
import { sentryApplicationKeys } from 'booksprout-app/src/sentry/applicationKeys'
import {
  applySentryNoiseCandidateTags,
  shouldDropAfterLeaveTransitionNoise,
  shouldDropBodylessDocumentNoise,
  shouldDropBrowserExtensionNoise,
  shouldDropQuasarLoadingBodyNullNoise,
  shouldDropSharedSentryNoise
} from 'booksprout-app/src/sentry/filtering'

export default ({ app, router }) => {
  if (process.env.BUILD_MODE !== 'sandbox') {
    Sentry.init({
      app,
      dsn: 'https://2a7edcc1962045ebbdefd40ec71d30ba@o4504832385613824.ingest.sentry.io/4504835379101696',
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.captureConsoleIntegration({
          levels: ['error']
        }),
        Sentry.thirdPartyErrorFilterIntegration({
          filterKeys: [sentryApplicationKeys.website],
          behaviour: 'apply-tag-if-exclusively-contains-third-party-frames'
        })
      ],
      tracePropagationTargets: ['localhost', 'booksprout.co', /^\//],
      tracesSampleRate: 0.2,
      environment: process.env.BUILD_MODE,
      ignoreErrors: [
        'ResizeObserver',
        'DataCloneError',
        'Termly',
        /Non-Error promise rejection captured with keys: message/,
        'Beacon',
        'NavigationDuplicated',
        /timeout of 5000ms exceeded/,
        'Loading chunk',
        'Loading CSS chunk'
      ],
      trackComponents: true,
      release: bsConstants.APP.VERSION,
      attachStacktrace: true,
      denyUrls: [
        /pagead\/js/i,
        /graph\.facebook\.com/i,
        /connect\.facebook\.net\/en_US\/all\.js/i,
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        /extensions\//i,
        /^chrome:\/\//i,
        /chrome-extension:/i,
        /safari-extension:/i,
        /safari-web-extension:/i,
        /moz-extension:/i,
        /^user-script:/i,
        /127\.0\.0\.1:4001\/isrunning/i,
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        /app.termly.io/i,
        /beacon-v2.helpscout.net/i,
        /.maze.co/i,
        /.adblockultimate.net/i,
        /c.amazon-adsystem.com/i,
        /anonymous/i,
        /webkit-masked-url/i,
        /w88p9x.com/i,
        /google-analytics.com/i
      ],
      beforeSend (event) {
        const userAgent = event.request?.headers?.['User-Agent']
        const errors = event.exception?.values

        if (userAgent?.includes('BingPreview') || userAgent?.includes('facebook')) {
          return null
        }

        if (shouldDropSharedSentryNoise(event)) {
          return null
        }

        if (shouldDropBrowserExtensionNoise(event)) {
          return null
        }

        if (shouldDropAfterLeaveTransitionNoise(event)) {
          return null
        }

        if (shouldDropQuasarLoadingBodyNullNoise(event)) {
          return null
        }

        if (shouldDropBodylessDocumentNoise()) {
          return null
        }

        event = applySentryNoiseCandidateTags(event)

        if (errors?.some((e) => e.type === 'NavigationDuplicated')) {
          return null
        }

        if (event.request?.url?.includes('maintenance')) {
          return null
        }

        if (errors?.some((e) => e.stacktrace?.frames?.some((frame) => frame.filename === '<anonymous>'))) {
          return null
        }

        if (errors?.some((e) => e.mechanism?.handled)) {
          return null
        }

        if (errors?.some((e) => e.value?.includes('timeout of 5000ms exceeded'))) {
          return null
        }

        return event
      },
      beforeSendTransaction (event) {
        if (!event.contexts?.trace?.status) {
          return null
        }

        return event
      }
    })
  }
}
